import { SagaIterator } from 'redux-saga';
import { put, call, takeLatest, StrictEffect, select } from 'redux-saga/effects';

import { stopAuditSuccess, stopAudit, stopAuditError } from './index';
import { apiInstance } from 'src/services/interceptor';
import { PayloadAction } from '@reduxjs/toolkit';

interface PayloadProps {
  user?: string | null;
  id?: string | null;
  siteUUID?: string | null;
}

function* postStopAudit({ payload }: PayloadAction<PayloadProps>): SagaIterator {
  try {
    const response = yield call(apiInstance.get, `reporttool/audit/stop/${payload?.siteUUID}`);
    yield put(stopAuditSuccess(response.data));
  } catch (e) {
    yield put(stopAuditError());
  }
}

function* stopAuditSaga(): Generator<StrictEffect, void> {
  yield takeLatest(stopAudit.type, postStopAudit);
}

export { stopAuditSaga };
